import { makeService } from './api';

const service = makeService('meetings');

export default service;